//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ModelSelect, ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";

export default {
components: {
    ModelSelect,
    ModelListSelect
},

data() {
    return {
    form: {
        id: "",
        nama: "",
        nip: "",
        gelar_depan: "",
        gelar_belakang: "",
        ttl: "",
        tempat_lahir: "",
        jenis_kelamin: "",
        status_keluarga: "",
        status_keluarga_uraian: "",
        agama: "",
        agama_uraian: "",
        pendidikan_ahir: "",
        pendidikan_ahir_uraian: "",
        sekolah: "",
        thn_lulus: "",
        tmt_cpns: "",
        gol: "",
        gol_uraian: "",
        tmt_golongan: "",
        jabatan: "",
        tmt_jabatan: "",
        no_karpeg: "",
        taspen: "",
        NPWP: "",
        alamat: "",
        kota_asal: "",
        kode_pos: "",
        kontak: "",
        tmt_gol: "",
        nm_sekolah: "",
        pendidikan_formal_thn_lulus: "",
        file: null,
        file_old: "",
        unit_kerja: ""
    },
    filterku: {
        instansi: "",
        unit_kerja: "",
        filter_berdasarkan: "MASA_KERJA",
        fileStat: false,
        user_id : ''
    },
    nm_jabatan : '',
    nm_unit_kerja : '',

    instansi_id : '',
    unit_kerja : '',
    unit_kerja_full : '',
    unit_kerja_edit : '',

    file_old : '',

    modal_riwayat : false,
    modal_riwayat_jenis : '',
    modal_riwayat_title : '',


    profileSIASN : null,
    loadSIA : true,
    list_data : [],
        


    };
},
methods: {
    getView: function() {
    //   this.cek_load_data = true;
        fetch(this.$store.state.url.URL_simpeg_biodata + "view", {
        method: "POST",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
            data_ke: 1,
            cari_value: '',
            unit_kerja: this.filterku.unit_kerja,
            page_limit: 1,
            user_id : this.filterku.user_id
        })
        })
        .then(res => res.json())
        .then(res_data => {
            // console.log(res_data.data)
            this.list_data = res_data.data;
            this.page_last = res_data.jml_data;
            this.selectData(res_data.data[0])
        //   this.cek_load_data = false;
        });
    },



    getProfileSIASN: function() {


        this.loadSIA = true

        fetch(this.$store.state.url.URL_simpeg_biodata + "si_asn_viewOne", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                nip: this.form.nip,
            })
            })
            .then(res => res.json())
            .then(res_data => {
                console.log("tes: ", res_data)
            this.profileSIASN = res_data.data;
            this.loadSIA = false
        });
    },


openModal(data, title){
    this.modal_riwayat = true;
    this.modal_riwayat_jenis = data;
    this.modal_riwayat_title = title
},

selectData: function(data) {
    this.form.id = data.id;
    this.form.nama = data.nama;
    this.form.nip = data.nip;
    this.form.gelar_depan = data.gelar_depan;
    this.form.gelar_belakang = data.gelar_belakang;
    this.form.ttl = data.ttl;
    this.form.tempat_lahir = data.tempat_lahir;
    this.form.jenis_kelamin = data.jenis_kelamin;
    this.form.status_keluarga = data.status_keluarga;
    this.form.status_keluarga_uraian = data.status_keluarga_uraian;
    this.form.agama = data.agama;
    this.form.agama_uraian = data.agama_uraian;
    this.form.pendidikan_ahir = data.pendidikan_ahir;
    this.form.pendidikan_ahir_uraian = data.pendidikan_ahir_uraian;
    this.form.sekolah = data.sekolah;
    this.form.thn_lulus = data.thn_lulus;
    this.form.tmt_cpns = data.tmt_cpns;
    this.form.gol = data.gol;
    this.form.gol_uraian = data.gol_uraian;
    this.form.tmt_golongan = data.tmt_golongan;
    this.form.jabatan = data.jabatan;
    this.form.tmt_jabatan = data.tmt_jabatan;
    this.form.no_karpeg = data.no_karpeg;
    this.form.taspen = data.taspen;
    this.form.NPWP = data.NPWP;
    this.form.alamat = data.alamat;
    this.form.kota_asal = data.kota_asal;
    this.form.kode_pos = data.kode_pos;
    this.form.kontak = data.kontak;
    this.form.tmt_gol = data.tmt_gol;
    this.form.nm_sekolah = data.nm_sekolah;
    this.form.pendidikan_formal_thn_lulus = data.pendidikan_formal_thn_lulus;
    this.form.unit_kerja = data.unit_kerja;

    this.form.file_old = data.file;
    this.file_old = data.file;

    this.instansi_id = data.instansi_id;
    this.unit_kerja_edit = data.unit_kerja;

    this.cek_edit = true;
    this.nm_unit_kerja = data.nm_unit_kerja;
    this.nm_jabatan = data.nm_jabatan;

    if (data.file == "" || data.file == null || data.file == undefined) {
    this.filterku.fileStat = false;
    } else {
    this.filterku.fileStat = true;
    }

    // DATA_MASTER.getJabatan(this.form.unit_kerja);
},

// ====================================== PAGINATE ====================================
Notify: function(message, positive, icon) {
    this.$q.notify({
    message: message,
    color: positive,
    icon: icon,
    position: "top",
    timeout: 500
    });
}

// ====================================== PAGINATE ====================================
},

mounted() {
    var get_profile = JSON.parse(localStorage.profile);

    this.filterku.unit_kerja = get_profile.profile.unit_kerja;
    this.filterku.instansi = get_profile.profile.instansi_id;
    this.filterku.user_id = get_profile.profile.user_id;

    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;

    this.form.instansi = get_profile.profile.instansi_id;
    this.form.unit_kerja = get_profile.profile.unit_kerja;

    this.form.nip = get_profile.profile.nip

    DATA_MASTER.getInstansi();
    DATA_MASTER.getUnitKerja(this.filterku.instansi);

    // this.getView();

    this.getProfileSIASN();
}
};
